<template>
  <div class="app-user">
    <AppAvatar
      :user="user"
      :actions="actions"
    />

    <div class="app-user__data">
      <p class="appbar__name">
        {{ user | fullName }}
      </p>

      <p class="app-user__position">
        {{ user.title }}
      </p>
    </div>

    <v-spacer />

    <slot name="menu" />
  </div>
</template>

<script>
import AppAvatar from '@/components/UI/AppAvatar.vue';

export default {
  components: {
    AppAvatar,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
    actions: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.app-user {
  display: flex;
  align-items: center;
  padding: 8px 0;

  &__data {
    margin-left: 16px;
  }
  &__name {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }
  &__position {
    font-size: 10px;
    line-height: 14px;
    max-width:230px;
  }
}
</style>
